<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Pendencias">
      </page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12 mb-3">
            <anosafra-multiselect 
              v-model="filter.ano_safra"
              label="Ano Safra"
            />
          </div>
          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Região</label>
            <multiselect
              v-model="filter.region"
              :options="regions"
              placeholder="Selecione a Região"
              label="name"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="id"
            />
          </div>

          <div class="col-md-4 col-sm-12 mb-3">
            <label class="form-control-label">Gerente Comercial</label>
            <multiselect
              v-model="filter.manager"
              :options="managers"
              :loading="isLoadingManagers"
              placeholder="Selecione o Gerente Comercial"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              :disabled="!currentUser.is_admin && currentUser.is_manager"
              label="name"
              track-by="id"
            />
          </div>

          <div class="col-md-6 col-sm-12 mb-3">
            <label class="form-control-label d-block mb-2 mt-3">Vendedor</label>
            <multiselect
              v-model="filter.salesman"
              :options="salesmans"
              :loading="isLoadingSalesman"
              :disabled="!currentUser.is_admin && !currentUser.is_manager"
              label="name"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              placeholder="Selecione o Vendedor"
              track-by="id"
              @input="findClients('')"
            />
          </div>

          <div class="col-md-6 col-sm-12 mb-3">
            <label class="form-control-label d-block mb-2 mt-3">Cliente</label>
            <multiselect
              v-model="filter.client"
              :options="filter.clients"
              placeholder="Selecione o Cliente"
              label="razao_social"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
              track-by="id"
              :show-no-options="false"
              @search-change="findClients"
            />
          </div>
        </div>
        <div class="row justify-content-end" style="padding: 1rem">
          <base-button 
            type="neutral"
            color="green"
            @click="clearFilters"
            >Limpar Filtros
          </base-button>
        </div>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" @click="generatePDF">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2" @click="exportToExcel()">Gerar Excel</base-button>
           <base-button type="primary" class="ml-2 mt-2" @click="generateReport" v-loading="isLoading"
            >Gerar Relatório</base-button>
        </div>
      </card>
    </div>

    <card v-show="pendencies.length" ref="report" v-loading="isLoading">
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Histórico - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          v-if="filter.ano_safra && Object.keys(filter.ano_safra).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Ano Safra - {{ filter.ano_safra.descricao }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Histórico - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          v-if="filter.ano_safra && Object.keys(filter.ano_safra).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Ano Safra - {{ filter.ano_safra.descricao }}
        </h6>
        <h6
          v-if="filter.region && Object.keys(filter.region).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Filial - {{ filter.region.name }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.manager && Object.keys(filter.manager).length"
        >
        Gerente Comercial - {{ filter.manager.name }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.salesmen && Object.keys(filter.salesmen).length"
        >
          Vendedor: {{ filter.salesmen.name }}
        </h6>
        <h6
          v-if="filter.client && Object.keys(filter.client).length"
          class="text-uppercase text-muted ls-1 mb-1"
        >
          Cliente - {{ filter.client.razao_social }}
        </h6>
        <br />
        <br />
        <br />
        <br />
      </div>
      <el-table
        class="table-responsive table-striped"
        header-row-class-name="thead-light"
        :data="pendencies"
      >
        <el-table-column min-width="155" prop="code" label="Cod. Cliente" />
        <el-table-column min-width="165" prop="razao_social" label="Cliente" />
        <el-table-column min-width="155" prop="region" label="Filial" />
        <el-table-column min-width="155" prop="manager" label="Gerente Comercial" />
        <el-table-column min-width="155" prop="salesman" label="Vendedor" />
        <el-table-column min-width="155" prop="pendency" label="Complemento" />
        <el-table-column min-width="155" prop="cultures" label="Cultura" />
        <el-table-column min-width="155" prop="cicles" label="Ciclos" />
        <el-table-column min-width="155" prop="technological_index" label="IT" />
      </el-table>
      <div slot="footer" class="py-4 d-flex justify-content-end">
        <base-pagination
          v-on:input="changePage"
          v-model="paginated_data['current']"
          :total="paginated_data['count']"
          :perPage="paginated_data['per_page']"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

import { Table, TableColumn, DatePicker } from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    AnosafraMultiselect,
    [DatePicker.name]: DatePicker,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      active: true,
      filter: {
        manager: {},
        salesman: {},
        region: {},
        ano_safra: {},
        client: {},
        clients: [],
      },
      paginated_data: [],
      pendencies: [],
      regions: [],
      ano_safras: [],
      managers: [],
      salesmans: [],
      lastEdition: new Date(),
      currentUser: {},
      isLoadingSalesman: false,
      isLoadingManagers: false,
      isLoading: false,
    };
  },
  methods: {
    clearFilters() {
      this.filter.manager = {},
      this.filter.salesman = {},
      this.filter.region = {},
      this.filter.ano_safra = {},
      this.filter.client = {},
      this.filter.clients = []
    },
    generatePDF() {
      window.print();
    },
    exportToExcel() {
      return this.$exportToExcel();
    },
    clearFilters() {
      this.filter.region = "",
      this.filter.manager = ""
      this.filter.salesman = "",
      this.filter.client = ""
    },
    generateReport(q = null, page = null) {

      this.isLoading = true
      this.$http.secured
        .get("/api/v1/report/pendencies", {
          params: {
            page: page,
            q: q,
            manager_id: this.filter.manager
              ? this.filter.manager.id
              : null,
            "regions[id]": this.filter.region
              ? this.filter.region.id
              : null,
            salesman_id: this.filter.salesman
              ? this.filter.salesman.id
              : null,
            anosafra_id: this.filter.ano_safra
              ? this.filter.ano_safra.id
              : null,
            id: this.filter.client
              ? this.filter.client.id
              : null,
          },
        })
        .then((response) => {
          this.paginated_data = response.data;
          this.lastEdition = new Date();
          this.pendencies = this.paginated_data[" pendencies"];
          this.isLoading = false
        });
    },
    initRegions() {
      this.$http.secured.get("/api/v1/regions").then((response) => {
        this.regions = response.data;
      });
    },
     findClients(query) {
      var data = {
        per_page: 10,
        q: {},
      };

      if (query.trim()) data.q.razao_social = query;
      if (this.filter.salesman && this.filter.salesman.id)
        data.q.user_ids = this.filter.salesman.id;

      this.$http.secured
        .get("/api/v1/clients", { params: data })
        .then((response) => {
          this.filter.clients = response.data.clients;
        })
        .catch(() => {
            // (this.$toasted.defaultError())
          }
        );
    },
    initManagers(query) {
      this.isLoadingManagers = true
      var data = {
        q: { name: query, is_manager: true, status: this.active },
      }
      if(this.filter.ano_safra && this.filter.ano_safra.id)
        data.q['anosafra_id'] = this.filter.ano_safra.id

      this.$http.secured
        .get("/api/v1/users", {params: data})
        .then((response) => {
          this.managers = response.data.users || [];
          this.isLoadingManagers = false;
        })
        .catch(() => {
          this.isLoadingManagers = true;
        });
    },
    initSalesmen(query) {
      this.$http.secured
        .get("/api/v1/users", {
          params: {
            q: { 
              is_salesman: true,
              name:        query,
              manager_id: this.filter.manager && this.filter.manager.id,
              anosafra_id: this.filter.ano_safra && this.filter.ano_safra.id
            },
          },
        })
        .then((response) => {
          this.filter.salesmans = response.data;
          this.salesmen = response.data.users;
          this.salesmans = this.salesmen;
          this.loadingSalesmen = false;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    changePage(page) {
      let filterInput = null;
      if (this.filtered) filterInput = this.filter;
      this.generateReport(filterInput, page);
    },
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    }
  },
  mounted() {
    this.initRegions();
    this.findClients("");

    this.currentUser = this.$currentUser();
    if (this.currentUser.is_manager && !this.currentUser.is_admin) {
      this.filter.managers = [this.currentUser];
      this.filter.manager = this.currentUser;
    }
    else if (this.currentUser.is_salesman && !this.currentUser.is_admin) {
      this.filter.managers = [this.currentUser.manager];
      this.filter.manager = this.currentUser.manager;
      this.filter.salesmans = [this.currentUser]
      this.filter.salesman = this.currentUser
    }
  },
  watch: {
    "filter.ano_safra": function () {
      if(this.$can('index', 'user')){
        this.initSalesmen("");
      }
      if(this.currentUser.is_admin)
        this.initManagers('');
    },
    "filter.manager": function () {
      if(this.$can('index', 'user')){
        this.initSalesmen("");
      }
      if(this.currentUser.is_admin || this.currentUser.is_salesman);
    },
  },
};
</script>
<style>
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
</style>
